import React, { FC } from 'react'
import { Box } from '../../../UI'
import { Heading } from '../../../UI/Heading'
import * as ContactInformationStyles from './ContactInformation.styles'

type ContactInformationProps = React.ComponentPropsWithoutRef<"div"> & {
  title?: string
}

const ContactInformation: FC<ContactInformationProps> = props => {
  const { children, title } = props
  return (
    <ContactInformationStyles.Container>
      <Box display="flex" alignItems="center">
        <Heading
          fontFamily="Roboto"
          fontSize={['18px', '24px']}
          fontWeight={['700']}
          lineHeight={['28px', '48px']}
          textAlign="center"
          margin={['18px', '18px']}
          width={['auto', '688px']}
        >
          {title}
        </Heading>
      </Box>
      <Box flexDirection={['column', 'row']}>{children}</Box>
    </ContactInformationStyles.Container>
  )
}

export default ContactInformation
